t = require('views/internal/teacup-with-helpers')('confirm_merge')

module.exports = ->
  t.p ->
    t.text t.mustacheVar('text')

  t.ul '.pop-over-member-list.js-member'

  t.input '.js-confirm.full', { type: 'submit', value: t.mustacheVar('confirmText') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/confirm_merge.coffee